export function getExt(value: string): string {
	return value.slice(value.lastIndexOf('.') + 1);
}
